import {
  Box,
  Avatar,
  Image,
  Button,
  Menu,
  MenuButton,
  MenuList,
  Flex,
  Text,
  useMediaQuery,
  MenuDivider,
  Spacer,
  Tooltip
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';
import { useMsal } from '@azure/msal-react';
import React, { useEffect, useState } from 'react';
import { loginRequest } from '../authConfig';
import { getProfileData, getProfilePhoto } from '../_sys/graph';

export default function SignOutButton () {
  const [isSmaller1024] = useMediaQuery('(max-width: 1024px)');
  const { instance, accounts } = useMsal();
  const [profileData, setProfileData] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);

  function handleLogout (instance) {
    instance.logoutPopup().catch((e) => {
      console.error(e);
    });
  }

  useEffect(() => {
    const profile = async () => {
      const request = {
        ...loginRequest,
        account: accounts[0]
      };
      const silentToken = await instance.acquireTokenSilent(request).catch(() => instance.acquireTokenPopup(request));
      const profile = await getProfileData(silentToken.accessToken);
      const photo = await getProfilePhoto(silentToken.accessToken);
      setProfileData(profile);
      const photoURL = URL.createObjectURL(photo);
      setProfilePhoto(photoURL);
    };
    profile();
  }, []);

  return (
    profileData
      ? (
        <>
          <Menu>
            <Box
              padding="2"
              margin="2"
              maxW="sm"
            >
              <Text fontSize="sm"> 
               Welcome, {profileData.givenName}
              </Text>
            </Box>
            <MenuButton
              as={Button}
              rounded="sm"
              variant="link"
              cursor="pointer"
              minW={0}
              paddingRight={1}
            >
              <Avatar
                size="md"
                src={profilePhoto}
              />
            </MenuButton>
            <MenuList>
              <Box padding="1" margin="2">
                <Image
                  borderRadius="lg"
                  boxSize={isSmaller1024 ? '3xs' : '2xs'}
                  objectFit="contain"
                  src={profilePhoto}
                />
                <Text fontSize="sm">{profileData.jobTitle}</Text>
                <Text fontSize="xs">{profileData.mail}</Text>
                <MenuDivider />
                <Flex>
                  <Box />
                  <Spacer />
                  <Box>
                    <Tooltip label="Logout from your TRC account">
                      <Button
                        width="max-content"
                        border="1px"
                        borderColor="red.100"
                        rightIcon={<WarningIcon />}
                        onClick={() => handleLogout(instance)}
                      >
                                                Logout
                      </Button>
                    </Tooltip>
                  </Box>
                </Flex>
              </Box>
            </MenuList>
          </Menu>
        </>
      )
      : null
  );
}
